import { Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router';

import { TEllipsisBreadcrumb } from '@/shared/components/ui/ellipsis-breadcrumb/ellipsis-breadcrumb.types';

export const EllipsisBreadcrumb: React.FC<TEllipsisBreadcrumb> = ({
  linkTo,
}) => {
  return (
    <Link to={linkTo}>
      <Typography variant="p6" color="textPrimary">
        ...
      </Typography>
    </Link>
  );
};
